import {Box, Grid} from '@mui/material';
import React, {useState} from 'react';
import Lottie from 'lottie-react';
import puzzleAnimation from '../../assets/puzzle-anim/animation';
import awsAnimation from '../../assets/aws-svc-anim/animation';
import heroAnimation from '../../assets/hero-anim/animation';
import Form from './Form';
import backgroundImage from '../../assets/bck-img/bck-img.png'

const Registration = () => {
    const [animationData, setAnimationData] = useState(heroAnimation); // Initial animation data
    const [currentStep, setCurrentStep] = useState(1); // Current step state
    const [formSubmitted, setFormSubmitted] =useState(false);
    const [animationIndex, setAnimationIndex] = useState(0);
    // Function to download the PDF when the button is clicked
    // const handleDownloadPDF = () => {
    //     const pdfFileName = 'course-details';
    //     const pdfUrl = 'https://qa-blog-application-data-102954369745-us-east-1.s3.amazonaws.com/registration/course-broucher.pdf';

    //     const link = document.createElement("a");
    //     link.href = pdfUrl;
    //     link.download = pdfFileName;
    //     link.click();
    // }

    // Function to handle animation change when going to the next step
    const handleNextStep = (step) => {
        setCurrentStep(step);
        switch (step) {
            case 1:
                setAnimationData(heroAnimation);
                break;
            case 2:
                setAnimationData(awsAnimation);
                break;
            default:
                setAnimationData(puzzleAnimation);
                break;
        }
    };

    // Function to handle animation change when going to the previous step
    const handlePrevStep = (step) => {
        setCurrentStep(step);
        switch (step) {
            case 1:
                setAnimationData(heroAnimation);
                break;
            case 2:
                setAnimationData(awsAnimation);
                break;
            default:
                setAnimationData(puzzleAnimation);
                break;
        }
    };
     const playNextAnimation=()=>{
        console.log('play next animation')
           if(formSubmitted){
            console.log('next animation is loading...')
            switch (animationIndex) {
                case 0:
                    setAnimationData(heroAnimation);
                    break;
                case 1:
                    setAnimationData(awsAnimation);
                    break;
                default:
                    setAnimationData(puzzleAnimation);
                    break;
            }
            if(animationIndex>1){
                setAnimationIndex(0);
            }
            else{
                setAnimationIndex(prev=>prev+1);
            }
           }
     }
     const handleFormSubmit=()=>{
        console.log('handle form submit in index')
        setFormSubmitted(true);
     }
    return (
        <Box width={"100%"} sx={{display: "flex", alignItems: "center", height: "100vh",backgroundImage:`url(${backgroundImage})`,
        backgroundRepeat:'no-repeat',backgroundSize:'cover'}} className="mainBoxGrid">
            <Grid container spacing={2} justifyContent={'space-between'} className="tabletGrid"
                  style={{width: "1280px", margin: "0 auto"}}>
                <Grid item xs={12} xl={6} lg={6} md={6} className='registrationLayout'>
                    <Box className="registeration">
                        <Box className="leftBox">
                            <Form onFormSubmission={handleFormSubmit} onNextStep={handleNextStep} onPrevStep={handlePrevStep}/>
                        </Box>
                        <Grid item xs={12} xl={12} lg={12} md={12}>
                        {!formSubmitted && <p className='note'><span>*</span> Kindly fill out this form to get the course information brochure.</p>}
                        </Grid>
                    </Box>
                </Grid>

                <Grid item xs={12} xl={6} lg={6} md={6} className='gridBox registrationLayout'>
                    <Box className="rightSide">
                        <Box sx={{textAlign: "center"}} className="iframeVideo">
                            {animationData && 
                            <Lottie
                            animationData={animationData} 
                            onLoopComplete={playNextAnimation}
                            loop 
                            autoplay
                            />}
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Registration;
